import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Outlet } from "react-router-dom";
import auth from "../../firebase.init";
import useAdmin from "../../hooks/useAdmin";
import ActiveLink from "../Shared/ActiveLink";

const Dashboard = () => {
  const [user] = useAuthState(auth);
  const [admin] = useAdmin(user);
  return (
    <div class="drawer ">
      <input
        id="dashboard-sidebar2"
        type="checkbox"
        className="drawer-toggle"
      />
      <div className="drawer-content">
        <h2 className="lg:text-5xl text-3xl font-bold text-center text-accent py-6 px-1">
          Welcome to your Dashboard{" "}
          <div className="mt-3">
            <label
              htmlFor="dashboard-sidebar2"
              tabIndex="1"
              // for="dashboard-sidebar"
              className="btn btn-ghost border-2 border-neutral shadow-2xl text-neutral capitalize bg-gradient-to-r from-primary to-primary hover:from-green-500 hover:to-blue-500 hover:border-accent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                class="inline-block w-5 h-5 stroke-current"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </label>
          </div>
        </h2>
        <Outlet></Outlet>
      </div>
      <div className="drawer-side border-r-2 ">
        <label
          // for="my-drawer-2"
          htmlFor="dashboard-sidebar2"
          aria-label="close sidebar"
          className="drawer-overlay"
        ></label>
        <ul
          class="menu shadow-2xl p-4 overflow-y-auto w-60 border-r-2 bg-gradient-to-r from-primary to-primary text-base-content z-10"
          style={{ fontFamily: "Roboto" }}
        >
          <li>
            <ActiveLink to="/dashboard">Dashboard</ActiveLink>
          </li>
          <br />

          {!admin && (
            <li>
              <ActiveLink to="/dashboard/addReview">Add Review</ActiveLink>
            </li>
          )}

          <li>
            <ActiveLink to="/dashboard/profile">My Profile</ActiveLink>
          </li>
          {admin && (
            <>
              <li>
                <ActiveLink to="/dashboard/addPart">Add Products</ActiveLink>
              </li>
              <li>
                <ActiveLink to="/dashboard/manageParts">
                  Manage All Products
                </ActiveLink>
              </li>
              <li>
                <ActiveLink to="/dashboard/manageOrders">
                  Manage All Orders
                </ActiveLink>
              </li>

              <li>
                <ActiveLink to="/dashboard/manageUser">
                  Manage All User
                </ActiveLink>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Dashboard;
